const PRICE_FORMAT_ERROR = 'Use a dot for decimals, no thousands separator or currency sign'

export function validateCell (value, column) {
  const strValue = value === null || value === undefined ? '' : String(value).trim()

  if (column.mandatory && strValue === '') return 'Required field'
  if (strValue === '') return null

  switch (column.format) {
    case 'email':
      if (!/^(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(strValue)) {
        return 'Invalid email format'
      }
      break
    case 'currency':
      // Same rule as the server: "12,000" or "12 000" would be read as 12 there
      if (!/^-?\d+(\.\d+)?$/.test(strValue)) return PRICE_FORMAT_ERROR
      break
    case 'number':
    case 'decimal': {
      const numValue = strValue.replace(/[$,€£\s]/g, '')
      if (numValue === '' || Number.isNaN(Number(numValue))) return 'Invalid number'
      break
    }
    case 'integer':
      if (!/^-?\d+$/.test(strValue)) return 'Invalid integer'
      break
    case 'date':
    case 'datetime':
      if (Number.isNaN(Date.parse(strValue))) return 'Invalid date'
      break
    case 'url':
      try {
        new URL(strValue)
      } catch {
        return 'Invalid URL'
      }
      break
    case 'boolean': {
      const lower = strValue.toLowerCase()
      if (!['true', 'false', '1', '0', 'yes', 'no', 'y', 'n'].includes(lower)) return 'Invalid boolean'
      break
    }
    case 'phone':
      if (strValue.replace(/\D/g, '').length < 7) return 'Invalid phone number'
      break
    default:
      break
  }

  if (column.validation) {
    try {
      const regex = new RegExp(column.validation)
      if (!regex.test(strValue)) return 'Validation pattern failed'
    } catch {
      // invalid regex
    }
  }

  return null
}

export function validateRow (row, schema, rowIndex = 0) {
  const errors = []

  schema.columns.forEach((column) => {
    const error = validateCell(row[column.name], column)
    if (error) errors.push({ column: column.name, message: error })
  })

  return { rowIndex, errors, hasError: errors.length > 0 }
}
